// Constants for the contact form

export const child = "Barn";
export const Complain = "Klage";
export const website = "Forbedring af siden";
export const Question = "Andre Spørgsmål";
export const alertMessage = 'Venligst Vælg en dato får levering før du kan fortsætte!!';
export const menuMessage = 'Please select a meal before proceeding!!';



export const SCHOOL_DANISH_MESSAGES = {
  INACTIVE_SCHOOL_ERROR: "Skolen er ikke aktiv. Venligst opdater barnets skole, før du afgiver en bestilling.",
  UPDATE_SCHOOL_HINT: "Venligst opdater barnets skoleoplysninger",
  UPDATE_SCHOOL_BUTTON: "Opdater Skole",
  SCHOOL_STATUS_TITLE: "Skolestatus"
};